import Copyright from "./Copyright"
export default function Footer() {
    return (
        <footer className="footer-v2 mt-auto">
            <div className="container">
                <Copyright />
            </div>
        </footer>
    )
}